<template>
  <v-navigation-drawer
      v-model="drawer"
      app
      class="navigation-menu"
    >
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title color="primary"
          class="title text-center mt-3 mb-4 primary--text font-weight-bold"
          >
            {{ appName }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <div id="menu-left" class="menu-left">
        <default-list :items="menuLeft"/>
      </div>
    </v-navigation-drawer>
</template>

<script>
import DefaultList from './List'
import { get, sync } from 'vuex-pathify'

export default {
  name: 'DefaultMenuLeft',
  components: {
    DefaultList
  },
  computed: {
    appName: get('app/name'),
    drawer: sync('app/drawer'),
    menuLeft: get('menu/menuLeft')
  }
}
</script>

<style lang="scss">
  .v-application .title {
    font-size: 0.9rem !important;
  }
  .theme--light.navigation-menu.v-navigation-drawer {
    background-color: #333333 !important;
  }
  .theme--dark.navigation-menu.v-navigation-drawer {
    background-color: #000000 !important;
  }
  .theme--light .menu-left {
    a, .v-icon, label {
      color: #fafafa;
    }
    a.router-link-active {
      color: #4287f5;
      .v-icon {
        color: #4287f5;
      }
    }
  }
  .theme--dark .menu-left {
    a, .v-icon, label {
      color: #ffffff;
    }
    a.router-link-active {
      color: #4287f5;
      .v-icon {
        color: #4287f5;
      }
    }
  }
  .menu-left {
    ul {
      padding: 0;
      list-style: none;
      margin: 0;
      li {
        position: relative;
        a {
          font-size: 15px;
          text-decoration: none;
          padding: 7px 15px;
          display: flex;
          font-weight: 500;
          .v-icon {
            margin-right: 10px;
          }
        }
        label {
          margin: 20px 0 10px 0;
          padding: 0 15px;
          display: block;
          font-weight: 700;
        }
        ul {
          li a {
            padding-left: 45px;
          }
        }

        &:hover, &:focus {
          ul {
            display: block;
          }
        }
      }
    }
  }
</style>
